import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from '@modules/app-routing.module';
import { AppComponent } from '@components/app/app.component';
import { FooterComponent } from '@components/footer/footer.component';
import { ButtonComponent } from '@components/button/button.component';
import { HeaderComponent } from '@components/header/header.component';
import { ConverterComponent } from '@components/converter/converter.component';
import { UploadService } from '@services/upload.service';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { AdsenseModule } from 'ng2-adsense';

@NgModule({
  declarations: [
    AppComponent,
    ConverterComponent,
    HeaderComponent,
    FooterComponent,
    ButtonComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgxDropzoneModule,
    AdsenseModule.forRoot({
      adClient: 'ca-pub-6495373596935145'
    }),
  ],
  providers: [UploadService],
  bootstrap: [AppComponent]
})
export class AppModule { }
